import { GetterTree } from 'vuex';
import { GroupState } from './types';
import { RootState } from '../types';
import { Handout } from '@/interfaces/handouts/handouts';

export const getters: GetterTree<GroupState, RootState> = {
  /**
   * Returns the current fight for this user
   * @param state
   */
  journal(state) {
    return state.journal;
  },

  journalState(state) {
    return state.journalState;
  },

  roundShorts(state) {
    return state.roundsShort;
  },

  getRoundById(state) {
    return (roundId: string) => {
      return state.rounds.find((round) => round.id === roundId);
    };
  },

  members(state) {
    return state.members;
  },

  handouts(state): Handout[] {
    return state.handouts;
  },

  session(state) {
    return state.session;
  },
};
